import GrooveUIKitV2 from './groove-ui-kit';

const KitModal = GrooveUIKitV2.components.GsModal;
const focusable = 'button:not(:disabled),a[href],input:not(:disabled):not([type="hidden"]),select:not(:disabled),textarea:not(:disabled),iframe,[tabindex]:not([tabindex="-1"])';

function visible(element, panel) {
  for (let node = element; node && node !== panel; node = node.parentElement) {
    const style = window.getComputedStyle(node);
    if (node.hidden || style.display === 'none' || style.visibility === 'hidden') return false;
  }
  return true;
}

// Opt-in compatibility for refreshed dialogs only. The established kit render
// function, header and controls remain unchanged for protected consumers.
export default function createAccessibleModal() {
  return {
    name: 'GsAccessibleModal',
    extends: KitModal,
    props: { preventEscape: Boolean },
    watch: {
      value(open) {
        if (open) this.rememberAndFocus();
        else this.restoreOpener();
      },
    },
    mounted() {
      if (this.value) this.rememberAndFocus();
    },
    beforeDestroy() {
      this.restoreOpener();
    },
    methods: {
      rememberAndFocus() {
        this.modalOpener = document.activeElement;
        this.$nextTick(() => {
          if (this.value && this.$refs.panel) this.$refs.panel.focus();
        });
      },
      restoreOpener() {
        const opener = this.modalOpener;
        const panel = this.$refs.panel;
        const active = document.activeElement;
        if (opener && opener.isConnected && (active === document.body || (panel && panel.contains(active)))) opener.focus();
        this.modalOpener = null;
      },
      handleKeydown(event) {
        if (!this.value || !this.$refs.panel) return;
        const panels = document.querySelectorAll('.gs-modal__panel');
        if (panels.length && panels[panels.length - 1] !== this.$refs.panel) return;
        if (event.key === 'Escape') {
          if (!this.preventEscape) KitModal.methods.handleKeydown.call(this, event);
          return;
        }
        if (event.key !== 'Tab') return;
        const panel = this.$refs.panel;
        const items = Array.from(panel.querySelectorAll(focusable)).filter(node => node.tabIndex !== -1 && visible(node, panel));
        const first = items[0];
        const last = items[items.length - 1];
        const active = document.activeElement;
        if (!first) {
          event.preventDefault();
          panel.focus();
        } else if (event.shiftKey && (active === first || active === panel || !panel.contains(active))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (active === last || active === panel || !panel.contains(active))) {
          event.preventDefault();
          first.focus();
        }
      },
    },
  };
}
